import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	showFullListButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	showFullListButtonText: {
		id: 'jql-builder-basic-picker.async-select.show-full-list-button.show-full-list-button-text',
		defaultMessage: 'Show full list',
		description:
			'Initially we show the first few items on the list. Clicking this button will show the full list.',
	},
});
export default messages;
